import {operate} from '../../../../../../utils/config'
import {downFile} from '../../../../../../utils/util'
import {postFun,getFun} from '../../../../../../utils/httpFun'
import axios from 'axios'

// 报警主类
class DevicePolice{
  constructor(_this,project){

    DevicePolice._this = _this;
    DevicePolice.project = project;

    // 赋值首页的this
    this.homeThis = _this;
      
    // 项目id
    this.projectInfo = project;
  }

  // 首页查询列表接口
  getHomeList(){
    this.homeThis.$refs.PubTable.getDatas();
  }
}

// 联动报警的服务类 主表
export class Master extends DevicePolice{
  constructor(_this,project){
   
    super(_this,project);

    // 新增联动名称参数 主表也就是外层
    this.master = {
      id:'',
      name:'',
      projectId:this.projectInfo.id
    }

    this.setMethodThis(['setDefault']);
  }

  // 设置this指向
  setMethodThis(methods){
    methods.forEach(item => {
      this[item] = this[item].bind(this);
    });
  }

  // 导出主表信息
  exportMessage(ids){

    let parms = {
      ids:ids,
      keyWord:this.master.name,
      projectId:this.master.projectId
    }

    axios({
      method: 'post',
      headers: { 'Authorization': localStorage.getItem("YunWeiTikenBRJ") },
      url: operate.EXPROTLINKAGE,
      responseType: 'arraybuffer',
      data: parms,
    }).then(function (res) {
      if (res.status == 200) {
        downFile(res.data,'联动报警统计', 'xlsx');
      }
    });
  }

  // 设置默认值
  setDefault(_this){
    console.log(_this)
    this.master.id = '';
    this.master.name = '';
  }
}

// 联动报警的服务类 子表
export class Subtabulation extends DevicePolice{
  constructor(rootDevId){
    super(DevicePolice._this,DevicePolice.project);

    // 主表 id
    this.rootDevId = rootDevId;

    // 当前状态 query  setup
    this.status = 'query';

    // 增加状态 root 添加根节点 children 添加子节点 edit 编辑节点
    this.addStatus = 'root'

    // 设置子表联动的参数
    this.selectParam = {};

    // 当前设备id
    this.deviceId = 0;

    // 树形菜单的页面this
    this.threeThis = null;

    // 查询项目的参数
    this.projectArg = {
      current:1,
      size:50,
      param:{
        keyWord:''
      }
    }

    // 父节点 如果为一级默认为0
    this.parentId = 0;

    // 联动子表 增加 更新 参数
    this.devLinkArgs = {}

    // this.setMethodThis(['serachProject']);
  }

  // 获取子表信息
  getSubList(_this){

    this.threeThis = this.threeThis || _this;

    getFun(`${operate.GETDEVSUBLIST}/${this.rootDevId}`,{},res=>{
      this.threeThis.devList = res.data;
    })
  }
}